import { render, staticRenderFns } from "./TimeLeftToOrder.vue?vue&type=template&id=464cf31f"
import script from "./TimeLeftToOrder.vue?vue&type=script&lang=js"
export * from "./TimeLeftToOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports